export default "__VITE_ASSET__190dabf0__"